var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.fileFolder)?_c('div',[_c('div',[_vm._v(_vm._s("Users Shared"))]),_c('div',[(_vm.usersList)?_c('SelectDropdown',{attrs:{"multiple":true,"id":"user-selection","value":_vm.usersToShare,"options":_vm.usersList.map((user) => ({
                    id: user.id,
                    title: user.firstName + ' ' + user.lastName,
                }))},on:{"change":_vm.handleUserSelection}}):_vm._e(),_c('Button',{on:{"click":_vm.updateShareAccess}},[_vm._v(_vm._s(_vm.sharing ? "Please wait..." : "Update Access"))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }